/* eslint-disable react/jsx-no-duplicate-props */
import React, { useEffect, useState } from "react";
import { Typography, TextField, InputAdornment, Icon } from "@mui/material";
import NumberFormat from "react-number-format";
import { DefaultLoader } from "../../components";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { setFullRedemption, getWithdrawalBankList } from "../redux/action";
import {
  StepLabel,
  CustomButton,
  TermCondition,
  ButtonWrapper,
} from "../../components";
import { icons } from "../../constants";
import { Container, Row } from "./styles";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

const label = {
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: 1.4,
};

const WithdrawalSummary = props => {
  const {
    withdrawalBankList,
    setFullRedemption,
    history,
    match: {
      params: { amount },
    },
    loadingWithdrawalBankList,
    getWithdrawalBankList,
  } = props;

  const Bank = "Bank";
  const eWallet = "E-Wallet";

  const [isChecked, setChecked] = useState(false);
  const [withdrawalMethod, setWithdrawalMethod] = useState(Bank);

  useEffect(() => {
    getWithdrawalBankList({ rsp: false });
  }, []);

  const handleBack = () => {
    setFullRedemption(false);
    history.back();
  };

  if (withdrawalBankList.length === 0 && loadingWithdrawalBankList)
    return <DefaultLoader />;

  const fee = withdrawalBankList.length > 0 ? withdrawalBankList[0].fee : 0;

  return (
    <Container>
      <StepLabel
        title="Cash Out summary"
        containerStyles={{ margin: "16px 16px 22px" }}
        onClick={handleBack}
      />

      {/* Withdrawal details */}
      <div
        style={{
          backgroundColor: "#f1fafe",
          padding: "16px",
          margin: "0 16px",
          borderRadius: "4px",
        }}
      >
        <Row style={{ justifyContent: "space-between" }}>
          <Typography color="textPrimary">Cash Out amount</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={Number(amount).toFixed(2)}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>
        <Row style={{ justifyContent: "space-between", margin: "8px 0" }}>
          <Typography color="textPrimary">Bank transaction fee</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={parseFloat(fee)}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>
        <Row style={{ justifyContent: "space-between" }}>
          <Typography color="textPrimary" sx={label}>
            Total:
          </Typography>
          <Typography color="textPrimary" sx={label}>
            RM{" "}
            <NumberFormat
              value={parseFloat(amount - fee)}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>
      </div>

      {/* Withdrawal method */}
      <div style={{ margin: "16px 16px 0px" }}>
        <Typography
          sx={{
            ...label,
            color: "#003865",
          }}
        >
          Cash Out method
        </Typography>
        <div style={{ marginTop: "16px" }}>
          <TextField
            fullWidth
            variant="outlined"
            value={Bank}
            onClick={e => setWithdrawalMethod(e.target.value)}
            style={{ marginBottom: "22px" }}
            inputProps={{
              style: {
                padding: "16px 16px 16px 0",
                color: withdrawalMethod === Bank ? "#004c97" : "#333",
                fontWeight: withdrawalMethod === Bank ? "700" : "normal",
              },
            }}
            InputProps={{
              readOnly: true,
              style: { padding: 0, paddingLeft: "16px" },
              startAdornment: (
                <InputAdornment
                  position="start"
                  style={{ padding: 0, paddingRight: "16px", margin: 0 }}
                >
                  <img
                    src={icons.fpx}
                    alt="fpx"
                    style={{ margin: 0, padding: 0, width: "100%" }}
                  />
                </InputAdornment>
              ),
              endAdornment: withdrawalMethod === Bank && (
                <InputAdornment
                  position="end"
                  style={{ padding: 0, paddingRight: "16px", margin: 0 }}
                >
                  <DoneOutlinedIcon
                    sx={{ color: "#0076CF", fontSize: 24 }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>

      {/* Term conditions */}
      <Row
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          margin: "8px 16px 16px",
        }}
      >
        <TermCondition
          message="Withdrawal must be made with a bank account under your name (single account only). Withdrawal will be rejected if using someone else’s bank account."
          checked={isChecked}
          onChange={() => setChecked(!isChecked)}
          checkboxTestId="cashout-terms-and-conditions"
        />
      </Row>

      {/* Button */}
      <ButtonWrapper
        style={{
          backgroundColor: "#fff",
        }}
      >
        <CustomButton
          text="Next"
          variant="contained"
          color="#fff"
          backgroundColor="#1278cc"
          disabled={withdrawalMethod && isChecked ? false : true}
          onClick={() => history.push(`/make-withdrawal/bankInfo/${amount}`)}
        />
      </ButtonWrapper>
    </Container>
  );
};

const withConnect = connect(
  state => ({
    isFullRedemption: state.goal.isFullRedemption,
    withdrawalBankList: state.goal.withdrawalBankList,
    loadingWithdrawalBankList: state.goal.loadingWithdrawalBankList,
    loadingPPGToken: state.goal.loadingPPGToken,
  }),
  { setFullRedemption, getWithdrawalBankList }
);

export default compose(
  withRouter,
  withConnect
)(WithdrawalSummary);
